import {ActionTypeEnum, ResourceTypeEnum} from "../base/training-literals";

import ModelSelect from "./action-lists/model-select";
import VolumeSelect from "./action-lists/volume-select";
import MoveVolume from "./action-lists/move-volume";
import MoveModel from "./action-lists/move-model";
import MoveBranch from "./action-lists/move-branch";
import MoveGroup from "./action-lists/move-group";
import ExplodeModel from "./action-lists/explode-model";
import AlignWithPhysical from './action-lists/align-with-physical';
import ExplodeScene from "./action-lists/explode-scene";
import SceneTransformation from "./action-lists/scene-transformation";
import MediaScreenSelect from "./action-lists/media-screen-select";
import Highlight from "./action-lists/highlight";
import Transparency from "./action-lists/transparency";
import Visibility from "./action-lists/visibility";
import ResetModel from "./action-lists/reset-model";
import BaseAction from "./base-action";
import Wayfinding from "./action-lists/wayfinding";
import UserActionMoveObjects from "./action-lists/userAction-MoveObjects";
import Flash from "./action-lists/flash";
import Boundary from "./action-lists/boundary";
import TrackTime from "./action-lists/track-time";
import GetTimeDuration from "./action-lists/get-time-duration";
import BranchSelect from "./action-lists/branch-select";
import GroupSelect from "./action-lists/group-select";

class ActionController {
    constructor() {
        let self = this;
        this.allActions = [];
        this.currentAction = undefined;
        this.currentSubAction = undefined;
        wv.communicator.addEventListener(text_setCurrentTrainingAction, function (itemArr) {
            self.handleActionCallback(itemArr);
        });
        wv.communicator.addEventListener(text_setCurrentTrainingSubAction, function (itemArr) {
            self.handleActionCallback(itemArr, true);
        });

    }

    getActionInstance(action) {
        let thisAction = this.allActions.find(a => a.actionId === action.actionId);
        if (thisAction) {
            thisAction.init();
            return thisAction;
        }
        switch (action.type) {
            case ActionTypeEnum.MOVE_MODEL:
                thisAction = new MoveModel(action);
                break;
            case ActionTypeEnum.MOVE_VOLUME:
                thisAction = new MoveVolume(action);
                break;
            case ActionTypeEnum.MOVE_BRANCH:
                thisAction = new MoveBranch(action);
                break;
            case ActionTypeEnum.MOVE_GROUP:
                thisAction = new MoveGroup(action);
                break;
            case ActionTypeEnum.MODEL_SELECT:
                thisAction = new ModelSelect(action);
                break;
            case ActionTypeEnum.VOLUME_SELECT:
                thisAction = new VolumeSelect(action);
                break;
            case ActionTypeEnum.BRANCH_SELECT:
                thisAction = new BranchSelect(action);
                break;
            case ActionTypeEnum.GROUP_SELECT:
                thisAction = new GroupSelect(action);
                break;
            case ActionTypeEnum.MEDIA_SCREEN_SELECT:
                thisAction = new MediaScreenSelect(action);
                break;
            case ActionTypeEnum.EXPLODE_MODEL:
                thisAction = new ExplodeModel(action);
                break;
            case ActionTypeEnum.EXPLODE_SCENE:
                thisAction = new ExplodeScene(action);
                break;
            case ActionTypeEnum.SCENE_TRANSFORMATION:
                thisAction = new SceneTransformation(action);
                break;
            case ActionTypeEnum.HIGHLIGHT:
                thisAction = new Highlight(action);
                break;
            case ActionTypeEnum.TRANSPARENCY:
                thisAction = new Transparency(action);
                break;
            case ActionTypeEnum.VISIBILITY:
                thisAction = new Visibility(action);
                break;
            case ActionTypeEnum.RESET_MODEL:
                thisAction = new ResetModel(action);
                break;
            case ActionTypeEnum.ALIGN_WITH_PHYSICAL:
                thisAction = new AlignWithPhysical(action);
                break;
            case ActionTypeEnum.WAYFINDING:
                thisAction = new Wayfinding(action);
                break;
            case ActionTypeEnum.USER_ACTION_MOVE_OBJECTS:
                thisAction = new UserActionMoveObjects(action);
                break;
            case ActionTypeEnum.FLASH:
                thisAction = new Flash(action);
        		break;
            case ActionTypeEnum.TRACK_TIME:
                thisAction = new TrackTime(action);
                break;
            case ActionTypeEnum.GET_TIME_DURATION:
                thisAction = new GetTimeDuration(action);
                break;
            case ResourceTypeEnum.BOUNDARY:
                thisAction = new Boundary(action);
                break;
            default:
                thisAction = new BaseAction(action);
                break;
        }

        thisAction.init();
        this.allActions.push(thisAction);
        return thisAction;
    }

    setCurrentAction(action) {
        this.currentAction = action ? this.getActionInstance(action) : null;
    }

    setCurrentSubAction(action) {
        this.currentSubAction = action ? this.getActionInstance(action) : null;
    }

    getCurrentAction() {
        return this.currentAction;
    }

    getCurrentSubAction() {
        return this.currentSubAction;
    }

    getActiveAction() {
        return this.getCurrentAction() || this.getCurrentSubAction();
    }

    handleActionCallback(itemArr, isSubAction = false) {
        const action = {
            type: itemArr[0],
            actionId: itemArr[1],
        };

        this.getCurrentAction()?.cancel();
        this.getCurrentSubAction()?.cancel();

        if (action.type === '0') {
            isSubAction ? this.currentSubAction = undefined : this.currentAction = undefined;
            return;
        }

        this.setCurrentSubAction(isSubAction ? action : null);
        this.setCurrentAction(isSubAction ? null : action);
    }

    isActiveOperation(operationName) {
        if (this.currentAction?.isActiveOperation && typeof this.currentAction.isActiveOperation === 'function') {
            return this.currentAction.isActiveOperation(operationName);
        } else if (this.currentSubAction?.isActiveOperation && typeof this.currentSubAction.isActiveOperation === 'function') {
            return this.currentSubAction.isActiveOperation(operationName);
        }
        return false;
    }
}

export default new ActionController();
